<template>
<div>
  
  <div class="uk-position-relative uk-visible-toggle uk-light" tabindex="-1" uk-slideshow="velocity: .7;animation: push; pause-on-hover: false; autoplay: true;autoplay-interval:5000;">
    <!-- <div class="uk-slideshow-items">
            <div v-for="n in 2" :key="n.id" class="uk-position-cover uk-animation-kenburns uk-animation-reverse uk-transform-origin-center-left">
              <img :src="'/public/img/'+tipo+n+'.png'" alt="" uk-cover>
            </div>
    </div> -->
    <ul class="uk-slideshow-items">
        <li v-for="n in 2" :key="n.id">
            <img :src="'/public/img/'+tipo+n+'.jpg'" alt="" uk-cover>
        </li>
    </ul> 
    <a class="uk-position-center-left uk-position-small uk-hidden-hover" href="#" uk-slidenav-previous uk-slideshow-item="previous"></a>
    <a class="uk-position-center-right uk-position-small uk-hidden-hover" href="#" uk-slidenav-next uk-slideshow-item="next"></a>
  </div>
  <!--
  <div class="uk-overflow-hidden imgSlider">
      <h2>{{tipo}}</h2>
      <img v-bind:src="'/public/img/recursos/'+tipo" alt="Example image" class="uk-transform-origin-top-left" uk-scrollspy="cls: uk-animation-kenburns; repeat: true;">
  </div>
  <div class="uk-inline">

    <img src="/public/img/recursos/prueba.png" alt="">
    <div class="uk-position-center" style="top: 62%;
    left: 58%;
    width: 25%;">
      <img src="/public/img/100.png" alt="">
    </div>
  </div> -->
</div>
  
</template>
<style>
.imgSlider img{
  width: 100%;
}
</style>
<script>
export default {
  name: 'Slider',
  props: {
    tipo: String
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Slider.vue